import { createFileRoute, redirect } from '@tanstack/react-router';

// The reserve library now lives as a tab inside the "Tartalmak" page. This
// route is kept so existing links/bookmarks don't 404 — it redirects to the
// content page with the reserve tab pre-selected.
export const Route = createFileRoute('/app/reserve')({
  beforeLoad: () => {
    throw redirect({ to: '/app/content', search: { tab: 'reserve' } });
  },
});
